<div class="table-responsive rounded border" style="background: #ffffff; border-color: #e2e8f0 !important;" *ngIf="financialdata">
  <table class="table table-hover table-striped mb-0" style="font-size: 0.8125rem;">
    <thead style="background: var(--theme-primary, #123c53); color: #ffffff;">
      <tr>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">Type</th>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">Loan Amount</th>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">Interest</th>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">Agreement</th>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">EPI</th>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">Frequency</th>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">Tenure</th>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">IRR</th>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">Remark</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of financialdata">
        <td class="font-weight-bold text-dark">{{ row.Type }}</td>
        <td class="font-weight-bold text-primary">₹{{ row.LoanAmount }}</td>
        <td class="text-dark">₹{{ row.InterestAmt }}</td>
        <td class="text-dark">₹{{ row.AgreementValue }}</td>
        <td class="font-weight-bold text-success">{{ row.No_Of_Installment }}</td>
        <td class="text-dark">{{ row.EMIType }}</td>
        <td class="text-dark">{{ row.LoanTenure }} Months</td>
        <td class="text-dark">{{ row.IRR | number : "1.2-2" }}%</td>
        <td class="text-muted">{{ row.Financial_Remark || '-' }}</td>
      </tr>
    </tbody>
  </table>
</div>
